const fr = {
  // Navigation
  dashboard: "Tableau de bord",
  messages: "Messages",
  settings: "Paramètres",
  calendar: "Calendrier",
  search: "Recherche",
  favorites: "Favoris",
  resourceHub: "Centre de ressources",
  logout: "Déconnexion",
  admin: "Admin",
  
  // Dashboard
  quickActions: "Actions rapides",
  findProviders: "Trouver fournisseurs, emplois, parents, camps et programmes",
  upcomingEvents: "Événements à venir",
  addEvent: "Ajouter un événement",
  upgrade: "Mise à niveau",
  pendingBookings: "Réservations en attente",
  completeProfile: "Complétez votre profil",
  
  // Auth
  signIn: "Connexion",
  signUp: "Inscription",
  email: "Courriel",
  password: "Mot de passe",
  name: "Nom",
  forgotPassword: "Mot de passe oublié?",
  createAccount: "Créer un compte",
  alreadyHaveAccount: "Vous avez déjà un compte?",
  dontHaveAccount: "Vous n'avez pas de compte?",
  sendResetLink: "Envoyer le lien de réinitialisation",
  resetPassword: "Réinitialiser le mot de passe",
  newPasswordPlaceholder: "Min 8 car., maj, min, chiffre, spécial",
  passwordPolicy: "8+ caractères, majuscule, minuscule, chiffre, caractère spécial",
  checkYourEmail: "Vérifiez votre courriel",
  passwordReset: "Mot de passe réinitialisé!",
  invalidResetLink: "Lien de réinitialisation invalide",
  backToLogin: "Retour à la connexion",
  
  // Profile
  children: "Enfants",
  childrenLookingForCare: "enfants recherchant une garde",
  contactInfo: "Coordonnées",
  availability: "Calendrier de disponibilité",
  reviews: "Avis",
  noReviews: "Aucun avis pour le moment",
  writeReview: "Écrire un avis",
  needsPreferences: "Besoins et préférences",
  getDirections: "Obtenir l'itinéraire",
  viewProfile: "Voir le profil",
  peopleWhoSavedMe: "Personnes qui m'ont ajouté en favori",
  savedFavorites: "Favoris enregistrés",
  noFavorites: "Aucun favori pour le moment",
  browseNow: "Parcourir maintenant",
  
  // Bookings
  reserveDropIn: "Réserver une place sans rendez-vous",
  spotsAvailable: "places disponibles",
  bookNow: "Réserver",
  accept: "Accepter",
  decline: "Refuser",
  review: "Examiner",
  sendMessage: "Envoyer un message",
  sendDeclinedMessage: "Envoyer un message de refus",
  skip: "Passer",
  bookingAccepted: "Demande de réservation envoyée! Le fournisseur examinera et répondra.",
  report: "Signaler",
  reportEvent: "Signaler cet événement comme inapproprié?",
  reported: "Signalé — en cours d'examen",
  
  // Calendar
  operationsCalendar: "Calendrier des opérations",
  eventsCalendar: "Calendrier des événements",
  shareCalendar: "Partager le calendrier",
  syncCalendar: "Synchroniser",
  showToday: "Aujourd'hui",
  batchDelete: "Suppression par lot",
  
  // Messaging
  directMessages: "Direct",
  groups: "Groupes",
  newMessage: "Tapez un message...",
  send: "Envoyer",
  shareChildInfo: "Partager info enfant",
  requestChildInfo: "Demander info enfant",
  infoShared: "Info partagée",
  
  // Resources
  resources: "Ressources",
  formsAndDocuments: "Formulaires et documents",
  suggestResource: "Suggérer une ressource",
  viewPdf: "Voir le PDF",
  viewResource: "Voir la ressource",
  browseCollection: "Parcourir la collection",
  region: "Région",
  formType: "Type",
  allRegions: "Toutes les régions",
  allTypes: "Tous les types",
  pdfResources: "Ressources PDF",
  coloringPages: "Pages à colorier",
  
  // Contact / Support
  contactUs: "Nous contacter",
  faqs: "FAQ",
  privacyTerms: "Confidentialité et conditions",
  helpSupport: "Aide et soutien",
  bugReport: "Rapport de bogue",
  suggestion: "Suggestion",
  other: "Autre",
  sendMessageBtn: "Envoyer le message",
  messageSent: "Message envoyé!",
  sendUsMessage: "Envoyez-nous un message",
  reachUsDirectly: "Vous pouvez aussi nous joindre directement:",
  topic: "Sujet",
  message: "Message",
  yourName: "Votre nom",
  howCanWeHelp: "Comment pouvons-nous vous aider?",
  
  // Common
  save: "Enregistrer",
  cancel: "Annuler",
  delete: "Supprimer",
  edit: "Modifier",
  create: "Créer",
  submit: "Soumettre",
  confirm: "Confirmer",
  loading: "Chargement...",
  noResults: "Aucun résultat trouvé",
  moreInfo: "Plus d'infos",
  all: "Tout",
  active: "Actif",
  pending: "En attente",
  approved: "Approuvé",
  back: "Retour",
  sponsored: "Commandité",
  
  // Settings
  generalInfo: "Informations générales",
  changePassword: "Changer le mot de passe",
  currentPassword: "Mot de passe actuel",
  newPassword: "Nouveau mot de passe",
  confirmPassword: "Confirmer le mot de passe",
  downloadMyData: "Télécharger mes données",
  requestDeletion: "Supprimer mon compte",
  deleteMyAccount: "Supprimer mon compte",
  requiredField: "Indique un champ obligatoire",
  saveUpdates: "Enregistrer les modifications",
  
  // Admin
  adminPanel: "Panneau d'administration",
  overview: "Aperçu",
  users: "Utilisateurs",
  content: "Contenu",
  financials: "Finances",
  system: "Système",
  security: "Sécurité",
  auditLog: "Journal d'audit",
  ads: "Publicités",

  // Landing
  heroTitle: "Trouvez une garde d'enfants de confiance près de chez vous",
  heroSubtitle: "Connectez-vous avec des garderies, nounous, gardiennes et camps vérifiés dans votre quartier.",
  getStarted: "Commencer",
  getStartedFree: "Commencer gratuitement",
  browseProviders: "Parcourir les fournisseurs",
  whyUs: "Pourquoi ChildCareConnections & ElderCareConnections",
  joinThousands: "Rejoignez des milliers de familles et de fournisseurs qui utilisent déjà ChildCareConnections & ElderCareConnections.",
  trustedProviders: "Fournisseurs de confiance",
  trustedProvidersDesc: "Profils vérifiés avec avis, certifications et informations détaillées.",
  easyBooking: "Réservation facile",
  easyBookingDesc: "Réservez des places, planifiez des visites et gérez tout en un seul endroit.",
  safeSecure: "Sûr et sécurisé",
  safeSecureDesc: "Les informations de vos enfants sont privées et partagées uniquement avec votre consentement.",
  stayConnected: "Restez connecté",
  stayConnectedDesc: "Messagerie directe, discussions de groupe et notifications en temps réel.",
  readyToFind: "Prêt à trouver la garde d'enfants parfaite?",

  // Search
  searchProviders: "Rechercher des fournisseurs",
  mapView: "Carte",
  listView: "Liste",
  providers: "Fournisseurs",
  workers: "Travailleurs",
  parents: "Parents",
  camps: "Camps et programmes",
  neighborhoods: "Quartiers",
  city: "Ville",
  
  // FAQ
  faqTitle: "Foire aux questions",
  faqSubtitle: "Trouvez des réponses aux questions courantes",
  searchFaqs: "Rechercher dans la FAQ...",
  contactWithQuestion: "Contactez-nous avec votre question",
  
  // Privacy
  privacyPolicy: "Politique de confidentialité",
  termsOfService: "Conditions d'utilisation",
  
  // Subscription
  subscriptionPlans: "Plans d'abonnement",
  noteFromUs: "Un mot de notre part",
  yourPlan: "Votre plan",
  perMonth: "/mois",
  
  // Favorites
  peopleWhoFavoritedMe: "Personnes qui m'ont sauvegardé",
  noOneYet: "Personne ne vous a encore ajouté en favori",
  
  // Forgot Password
  forgotPasswordTitle: "Mot de passe oublié?",
  forgotPasswordSubtitle: "Entrez votre courriel et nous vous enverrons un lien de réinitialisation",
  emailAddress: "Adresse courriel",
  sending: "Envoi en cours...",
};

export default fr;
